import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";

export const UpdateAvatarUrl = `/do_update_avatar`;
export const UpdateAvatarMethod = ERequestType.TYPE_POST;

export interface UpdateAvatarBody extends ApiRequest {
	token: string;
	fileId: string;
}

export interface UpdateAvatarResponse extends ApiResponse {
}
